import { Reducer } from 'react';

import { ICity, ICityPayload } from '../../utils/types/admin-types';
import {
  Action,
} from '../../utils/types/state-types';
import {
  GET_CITY_RECEIVED,
  GET_CITY_REJECTED,
  GET_CITY_REQUESTED,
} from '../actions/admin-page';

export interface ICityReducerState {
  error?: string;
  city: ICity[] | [];
  isLoading: boolean;
}

const initialState = {
  city: [],
  error: '',
  isLoading: false,
} as ICityReducerState;

const cityReducer: Reducer<ICityReducerState, Action> = (
  state = initialState,
  action: Action,
) => {
  const { type } = action;
  switch (type) {
    case GET_CITY_REQUESTED: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }
    case GET_CITY_RECEIVED: {
      const { payload } = action as Action<ICityPayload>;
      return {
        ...state,
        isLoading: false,
        city: payload.city,
        error: '',
      };
    }
    case GET_CITY_REJECTED: {
      const { payload } = action as Action<ICityPayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    default:
      return state;
  }
};

export default cityReducer;
